import Cookies from 'js-cookie'

export const getToken = () => Cookies.get('token')

export const setToken = (token?: string, expires?: number, domain?: string) => {
  if (!token || !expires) return

  return Cookies.set('token', token, {
    // переводим минуты в дни
    expires: (expires % (60 * 24 * 365)) / (60 * 24),
    sameSite: 'None',
    secure: true,
    domain
  })
}

export const clearToken = (domain?: string) =>
  Cookies.remove('token', { domain })
